<template>
  <Dashboard>
    <!-- Analytics-table -->
    <div class="table-area hide-select-search">
      <h4 v-if="FacebookAutomatedCampaign.name">
        {{FacebookAutomatedCampaign.name}}
        <label class="switch" v-if="FacebookAutomatedCampaign.name != ''">
          <input type="checkbox" :checked="FacebookAutomatedCampaign.status == 'ACTIVE'" @change="campaignStatusUpdate()" />
          <span class="slider round"></span>
        </label>
      </h4>
      <table class="display" id="facebookAdsTable">
        <thead>
          <tr>
            <th class="all">Name</th>
            <th>Preview</th>
            <th>Status</th>
            <!-- <th class="all" style="width: 70px">action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="Ad in AutomatedAds" :key="Ad">
            <td>{{ Ad.name }}</td>
            <td>{{ Ad.preview_shareable_link }}</td>
            <td>{{ Ad.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Analytics-table -->
  </Dashboard>
</template>
<script>
import $ from "jquery";
// import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import "daterangepicker";
import Dashboard from "./../../../layouts/Dashboard.vue";
import getDealerOtherInfo from "../../../composeables/getDealerOtherInfo";
import axios from "axios";
export default {
  components: {
    Dashboard,
  },
  setup() {
    let FacebookAutomatedCampaign = ref({});
    let AutomatedAds = ref([]);

    // Get Dealer Other Info:
    const { dealer, dealerInfo, dealerInfoError, loadDealerInfo } =
      getDealerOtherInfo();
    loadDealerInfo().then(() => {
        getFacebookAutomatedCampaign();
        getFacebookAdAutomatedAds();
    });

    const getFacebookAdAutomatedAds = async () => {
      await axios
        .get(axios.defaults.baseUrl +"getFacebookAutomatedAds/",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("auth_token"),
            },
          }
        )
        .then((response) => {
          if (response.status) {
            if ($.fn.DataTable.isDataTable("#facebookAdsTable")) {
              $("#facebookAdsTable").DataTable().clear().destroy();
            }

            AutomatedAds.value = response.data.data.ads;

            setTimeout(() => {
              datatableInit();
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const campaignStatusUpdate = async () => {
      window.showHideMainLoader(true);
      let url = axios.defaults.baseUrl + "updateFacebookAutomatedCampaignStatus";
      
      if(FacebookAutomatedCampaign.value.status == 'PAUSED') {
        FacebookAutomatedCampaign.value.status = 'ACTIVE';
      }else {
        FacebookAutomatedCampaign.value.status = 'PAUSED';
      }

     

      window.showHideMainLoader(true);
      await axios
        .post(url, {
            status : FacebookAutomatedCampaign.value.status
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("auth_token"),
          },
        })
        .then((response) => {
          window.toast.fire({
            icon: response.data.status,
            title: response.data.data,
          });
        })
        .catch((error) => {
          if (error) {
            window.toast.fire({
              icon: "error",
              title: "Something went wrong, Please try again.",
            });
          }
        });
      window.showHideMainLoader(false);
    }

    const getFacebookAutomatedCampaign = async () => {
      await axios
          .get(
              axios.defaults.baseUrl + "getFacebookAutomatedCampaign",
              {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("auth_token"),
                },
              }
          )
          .then((response) => {
            FacebookAutomatedCampaign.value = response.data.data;
          })
          .catch((error) => {
            console.log(error);
          });
    }

    const datatableInit = async () => {
      $("#facebookAdsTable").addClass("nowrap").dataTable({
        responsive: true,
        order: [],
      });
    };

    onMounted(() => {
      datatableInit();
    });

    return {
      dealer,
      dealerInfo,
      dealerInfoError,
      AutomatedAds,
      FacebookAutomatedCampaign,
      campaignStatusUpdate
    };
  },
};
</script>